import React from "react";

export const LargeTitle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 27 27"
      fill="none"
    >
      <path
        d="M13.5789 20.8421H11.4737V13.4737H4.10526V20.8421H2V4H4.10526V11.3684H11.4737V4H13.5789V20.8421ZM22 8.21053V20.8421H19.8947V10.5305L17.7895 11.0947V8.91579L20.4211 8.21053H22Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SmallTitle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M1.97531 0V6.91358H8.88889V0H10.8642V15.8025H8.88889V8.88889H1.97531V15.8025H0V0H1.97531ZM16.2963 3.95062C18.3417 3.95062 30 5.60889 30 7.65432C20 8.50074 19.7156 9.28197 19.2375 9.90617L19.0914 10.084L15.8361 13.8272H19.7531V15.8025H12.8395V14.2657L17.6 8.78815C17.8647 8.48494 18.0247 8.0879 18.0247 7.65432C18.0247 6.70025 17.2504 5.92593 16.2963 5.92593C15.3896 5.92593 14.6459 6.6242 14.5738 7.5121L14.5679 7.65432H12.5926C12.5926 5.60889 14.2509 3.95062 16.2963 3.95062Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Body = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 27 27"
      fill="none"
    >
      <path
        d="M2.5 3.33337H17.5V5.00004H2.5V3.33337ZM2.5 9.16671H12.5V10.8334H2.5V9.16671ZM2.5 15H17.5V16.6667H2.5V15Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Quotes = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.81917 14.4342C2.96083 13.5225 2.5 12.5 2.5 10.8425C2.5 7.92583 4.5475 5.31167 7.525 4.01917L8.26917 5.1675C5.49 6.67083 4.94667 8.62167 4.73 9.85167C5.1775 9.62 5.76333 9.53917 6.3375 9.5925C7.84083 9.73167 9.02583 10.9658 9.02583 12.5C9.02583 13.2735 8.71854 14.0154 8.17156 14.5624C7.62458 15.1094 6.88271 15.4167 6.10917 15.4167C5.215 15.4167 4.36 15.0083 3.81917 14.4342ZM12.1525 14.4342C11.2942 13.5225 10.8333 12.5 10.8333 10.8425C10.8333 7.92583 12.8808 5.31167 15.8583 4.01917L16.6025 5.1675C13.8233 6.67083 13.28 8.62167 13.0633 9.85167C13.5108 9.62 14.0967 9.53917 14.6708 9.5925C16.1742 9.73167 17.3592 10.9658 17.3592 12.5C17.3592 13.2735 17.0519 14.0154 16.5049 14.5624C15.9579 15.1094 15.216 15.4167 14.4425 15.4167C13.5483 15.4167 12.6933 15.0083 12.1525 14.4342Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LongTextField = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.1667 15H2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 11.6666H2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1667 8.33337H2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 5H2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InputField = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_452_48448)">
        <path
          d="M1.66602 15.8333V4.16663H18.3327V15.8333H1.66602Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path d="M5 5.83337V14.1667" stroke="currentColor" strokeWidth="1.5" />
      </g>
      <defs>
        <clippath id="clip0_452_48448">
          <rect width="20" height="20" fill="white" />
        </clippath>
      </defs>
    </svg>
  );
};

export const Attachment = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 23 23"
      fill="none"
    >
      <path
        d="M12.3571 6.46415L7.64373 11.1783C7.56414 11.2552 7.50066 11.3471 7.45698 11.4488C7.41331 11.5505 7.39032 11.6598 7.38936 11.7705C7.3884 11.8811 7.40948 11.9909 7.45138 12.0933C7.49328 12.1957 7.55516 12.2887 7.63341 12.367C7.71165 12.4452 7.80469 12.5071 7.90711 12.549C8.00952 12.5909 8.11925 12.612 8.2299 12.611C8.34055 12.6101 8.4499 12.5871 8.55157 12.5434C8.65324 12.4997 8.7452 12.4362 8.82207 12.3567L13.5362 7.64332C14.0051 7.17444 14.2685 6.5385 14.2685 5.8754C14.2685 5.21231 14.0051 4.57637 13.5362 4.10749C13.0674 3.63861 12.4314 3.37519 11.7683 3.37519C11.1052 3.37519 10.4693 3.63861 10.0004 4.10749L5.28624 8.82165C4.8913 9.20676 4.57676 9.66645 4.36087 10.1741C4.14497 10.6817 4.03202 11.2271 4.02857 11.7787C4.02511 12.3303 4.13122 12.8771 4.34073 13.3874C4.55025 13.8977 4.859 14.3613 5.24908 14.7513C5.63916 15.1413 6.1028 15.45 6.61311 15.6595C7.12342 15.8689 7.67024 15.9749 8.22185 15.9714C8.77345 15.9679 9.31887 15.8548 9.82645 15.6389C10.334 15.4229 10.7937 15.1083 11.1787 14.7133L15.8929 9.99999L17.0712 11.1783L12.3571 15.8925C11.8154 16.4342 11.1723 16.8639 10.4645 17.1571C9.75673 17.4502 8.99815 17.6011 8.23207 17.6011C7.46599 17.6011 6.7074 17.4502 5.99963 17.1571C5.29187 16.8639 4.64877 16.4342 4.10707 15.8925C3.56537 15.3508 3.13566 14.7077 2.8425 13.9999C2.54933 13.2922 2.39844 12.5336 2.39844 11.7675C2.39844 11.0014 2.54933 10.2428 2.8425 9.53505C3.13566 8.82729 3.56537 8.18419 4.10707 7.64249L8.82207 2.92915C9.60791 2.17016 10.6604 1.75019 11.7529 1.75968C12.8454 1.76917 13.8904 2.20738 14.663 2.97991C15.4355 3.75244 15.8737 4.7975 15.8832 5.88998C15.8927 6.98247 15.4727 8.03498 14.7137 8.82082L10.0004 13.5367C9.76818 13.7688 9.49251 13.953 9.18912 14.0786C8.88573 14.2042 8.56056 14.2689 8.23219 14.2688C7.90382 14.2688 7.57867 14.2041 7.27531 14.0784C6.97195 13.9527 6.69632 13.7685 6.46415 13.5362C6.23199 13.304 6.04783 13.0283 5.92221 12.725C5.79658 12.4216 5.73194 12.0964 5.73198 11.768C5.73202 11.4397 5.79673 11.1145 5.92243 10.8111C6.04813 10.5078 6.23235 10.2322 6.46457 9.99999L11.1787 5.28582L12.3571 6.46415Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Columns = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.16667 4.16667H4.16667V15.8333H9.16667V4.16667ZM10.8333 4.16667V15.8333H15.8333V4.16667H10.8333ZM3.33333 2.5H16.6667C16.8877 2.5 17.0996 2.5878 17.2559 2.74408C17.4122 2.90036 17.5 3.11232 17.5 3.33333V16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V3.33333C2.5 3.11232 2.5878 2.90036 2.74408 2.74408C2.90036 2.5878 3.11232 2.5 3.33333 2.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Image = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M4.16667 9.25L5.83333 7.58333L10.4167 12.1667L13.3333 9.25L15.8333 11.75V4.16667H4.16667V9.25ZM4.16667 11.6075V15.8333H6.75L9.23833 13.3458L5.83333 9.94083L4.16667 11.6075ZM9.1075 15.8333H15.8333V14.1075L13.3333 11.6075L9.1075 15.8333ZM3.33333 2.5H16.6667C16.8877 2.5 17.0996 2.5878 17.2559 2.74408C17.4122 2.90036 17.5 3.11232 17.5 3.33333V16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V3.33333C2.5 3.11232 2.5878 2.90036 2.74408 2.74408C2.90036 2.5878 3.11232 2.5 3.33333 2.5ZM12.9167 8.33333C12.5851 8.33333 12.2672 8.20164 12.0328 7.96722C11.7984 7.7328 11.6667 7.41485 11.6667 7.08333C11.6667 6.75181 11.7984 6.43387 12.0328 6.19945C12.2672 5.96503 12.5851 5.83333 12.9167 5.83333C13.2482 5.83333 13.5661 5.96503 13.8005 6.19945C14.035 6.43387 14.1667 6.75181 14.1667 7.08333C14.1667 7.41485 14.035 7.7328 13.8005 7.96722C13.5661 8.20164 13.2482 8.33333 12.9167 8.33333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Video = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M1.66602 3.3275C1.66754 3.10865 1.7551 2.89918 1.90978 2.74435C2.06445 2.58951 2.27383 2.50175 2.49268 2.5H17.506C17.9627 2.5 18.3327 2.87083 18.3327 3.3275V16.6725C18.3312 16.8914 18.2436 17.1008 18.0889 17.2557C17.9342 17.4105 17.7249 17.4983 17.506 17.5H2.49268C2.27336 17.4998 2.0631 17.4125 1.90809 17.2573C1.75308 17.1022 1.66602 16.8918 1.66602 16.6725V3.3275ZM3.33268 4.16667V15.8333H16.666V4.16667H3.33268ZM8.85102 7.0125L12.9169 9.7225C12.9626 9.75293 13.0001 9.79418 13.026 9.84259C13.0519 9.89101 13.0655 9.94508 13.0655 10C13.0655 10.0549 13.0519 10.109 13.026 10.1574C13.0001 10.2058 12.9626 10.2471 12.9169 10.2775L8.85018 12.9875C8.80004 13.0207 8.74184 13.0398 8.68174 13.0426C8.62165 13.0455 8.56191 13.032 8.50886 13.0036C8.4558 12.9753 8.41141 12.9331 8.3804 12.8815C8.34938 12.83 8.33289 12.771 8.33268 12.7108V7.28917C8.33279 7.22888 8.34926 7.16974 8.38031 7.11807C8.41137 7.06639 8.45587 7.02411 8.50905 6.99572C8.56224 6.96733 8.62214 6.9539 8.68235 6.95685C8.74257 6.95981 8.80086 6.97904 8.85102 7.0125Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Walkthrough = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_393_15432)">
        <path d="M13.099 4.63273C13.1427 4.95406 13.2047 5.33233 12.9619 5.5635C12.7642 5.7517 12.4174 5.78155 12.1596 5.79495C11.9503 5.80583 11.675 5.84657 11.5267 5.68099C11.3901 5.5286 11.3817 5.19989 11.3664 5.01348C11.347 4.77556 11.2682 4.4694 11.4732 4.3295C11.6498 4.20906 12.0051 4.23685 12.2099 4.23512C12.4692 4.23293 12.7368 4.19722 12.9204 4.39515C13.0572 4.5426 13.1221 4.72392 13.2834 4.85893C13.7926 5.28514 14.5309 4.55425 14.0177 4.12463C13.6406 3.80897 13.573 3.3806 13.0229 3.24894C12.5378 3.13282 11.9381 3.17049 11.4529 3.26539C11.0142 3.35121 10.5369 3.55759 10.371 4.00605C10.1989 4.47107 10.3016 5.15539 10.4068 5.62895C10.6496 6.72103 11.5538 6.94271 12.5572 6.79659C13.0686 6.72213 13.605 6.49053 13.9225 6.06627C14.2841 5.5831 14.1766 4.91738 14.1004 4.35666C14.0108 3.69749 13.0101 3.97816 13.099 4.63273Z" fill="#64748B" />
        <path d="M15.4426 4.04738C15.7828 7.14243 13.3102 9.01068 11.9633 11.4846C12.2351 11.4496 12.5069 11.4145 12.7788 11.3795C11.2219 10.1129 9.57168 8.03665 9.10584 6.02856C8.71922 4.36199 9.13691 2.41778 10.8279 1.59947C12.7119 0.687785 15.3214 2.00666 15.3414 4.1119C15.3478 4.77976 16.3863 4.78142 16.3799 4.1119C16.3645 2.4959 15.9499 1.13208 14.2619 0.611668C12.5872 0.0953776 10.0761 0.235206 8.86876 1.66253C6.11603 4.91674 9.43403 9.99013 12.0445 12.1138C12.2928 12.3158 12.6865 12.3273 12.86 12.0087C14.349 9.27394 16.8546 7.4463 16.481 4.04738C16.4088 3.39028 15.3695 3.38293 15.4426 4.04738Z" fill="#64748B" />
        <path d="M15.1069 8.04841C15.764 8.04212 16.6481 7.87517 17.2968 8.02745C18.2157 8.24312 18.4746 8.38195 18.8306 9.4316C19.3626 10.9997 19.5113 12.6653 20.1551 14.2293C20.7713 15.7262 21.5243 17.076 21.8415 18.6778C22.1403 20.1864 22.3237 21.729 22.5617 23.2479C22.7286 23.0288 22.8955 22.8098 23.0624 22.5907C16.8039 22.566 10.5455 22.5413 4.28701 22.5167C3.61559 22.514 2.69415 22.7665 2.24278 22.2217C1.78359 21.6675 2.24031 20.862 2.39898 20.1915C2.74257 18.7396 3.08615 17.2877 3.42974 15.8358C3.80331 14.2573 4.16093 12.6738 4.55224 11.0996C4.67659 10.5993 4.78019 9.60702 5.08339 9.21792C5.96211 8.09025 7.44331 8.03508 8.70125 8.04689C9.36966 8.05317 9.37023 7.01471 8.70125 7.00843C7.44043 6.99659 5.74595 6.60673 4.74713 7.55538C3.89535 8.36438 3.71956 10.1449 3.45912 11.2041C2.96048 13.2322 2.49702 15.2697 2.01607 17.302C1.60329 19.0463 0.751496 21.1115 0.761998 22.9033C0.763441 23.1494 0.925513 23.3218 1.1432 23.4039C2.39681 23.8768 4.31081 23.5552 5.62811 23.5604C7.56525 23.568 9.50239 23.5757 11.4395 23.5833C15.3138 23.5986 19.1881 23.6139 23.0624 23.6291C23.4302 23.6306 23.6141 23.2978 23.5631 22.9719C23.2575 21.0214 23.1301 18.9181 22.5211 17.0339C21.8752 15.0357 20.7632 13.2515 20.2411 11.193C19.9613 10.0901 20.1644 8.19187 19.2986 7.35695C18.3979 6.48832 16.2025 6.99946 15.1069 7.00995C14.439 7.01634 14.4373 8.05482 15.1069 8.04841Z" fill="#64748B" />
        <path d="M12.3367 12.412C14.7587 12.4392 17.1807 12.4665 19.6027 12.4937C19.5154 12.1711 19.428 11.8486 19.3407 11.5261C16.1361 13.1325 12.8079 14.4464 9.34911 15.3955C6.57364 16.1571 4.63545 17.0668 2.18863 18.6104C1.76051 18.8805 1.92299 19.5784 2.4507 19.578C8.95711 19.5733 15.4635 19.5686 21.97 19.5639C22.6381 19.5635 22.6393 18.525 21.97 18.5255C15.4635 18.5302 8.95712 18.5349 2.4507 18.5396C2.53805 18.8621 2.62541 19.1846 2.71276 19.5071C4.03569 18.6725 5.38299 17.6238 6.8707 17.107C8.28505 16.6158 9.79598 16.3709 11.2306 15.93C14.2095 15.0145 17.0808 13.8184 19.8648 12.4228C20.3404 12.1843 20.0942 11.4607 19.6027 11.4552C17.1807 11.428 14.7587 11.4008 12.3367 11.3736C11.6682 11.3661 11.6678 12.4045 12.3367 12.412Z" fill="#64748B" />
      </g>
      <defs>
        <clipPath id="clip0_393_15432">
          <rect width="24" height="24" fill="white" transform="translate(0.166687)" />
        </clipPath>
      </defs>
    </svg>

  );
};

export const Quotes2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 3.33329H5.83333C5.39131 3.33329 4.96738 3.50889 4.65482 3.82145C4.34226 4.13401 4.16667 4.55793 4.16667 4.99996C4.16667 5.44199 4.34226 5.86591 4.65482 6.17847C4.96738 6.49103 5.39131 6.66663 5.83333 6.66663H17.5V17.5C17.5 17.721 17.4122 17.9329 17.2559 18.0892C17.0996 18.2455 16.8877 18.3333 16.6667 18.3333H5.83333C4.94928 18.3333 4.10143 17.9821 3.47631 17.357C2.85119 16.7319 2.5 15.884 2.5 15V4.99996C2.5 4.1159 2.85119 3.26806 3.47631 2.64294C4.10143 2.01782 4.94928 1.66663 5.83333 1.66663H16.6667C16.8877 1.66663 17.0996 1.75442 17.2559 1.9107C17.4122 2.06698 17.5 2.27895 17.5 2.49996V3.33329ZM4.16667 15C4.16667 15.442 4.34226 15.8659 4.65482 16.1785C4.96738 16.491 5.39131 16.6666 5.83333 16.6666H15.8333V8.33329H5.83333C5.24819 8.33423 4.6732 8.18042 4.16667 7.88746V15ZM16.6667 5.83329H5.83333C5.61232 5.83329 5.40036 5.7455 5.24408 5.58922C5.0878 5.43293 5 5.22097 5 4.99996C5 4.77895 5.0878 4.56698 5.24408 4.4107C5.40036 4.25442 5.61232 4.16663 5.83333 4.16663H16.6667V5.83329Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EmbedCode = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 23 23"
      fill="none"
    >
      <path
        d="M20 10L15.2858 14.7142L14.1075 13.5358L17.6433 10L14.1075 6.46417L15.2858 5.28583L20 10ZM2.35667 10L5.8925 13.5358L4.71417 14.7142L0 10L4.71417 5.28583L5.89167 6.46417L2.35667 10ZM8.15667 17.5H6.38333L11.8433 2.5H13.6167L8.15667 17.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ShortAnswerIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_393_15460)">
        <path d="M25.8125 14.625H1.4375C0.990625 14.625 0.625 14.9906 0.625 15.4375V17.0625C0.625 17.5094 0.990625 17.875 1.4375 17.875H25.8125C26.2594 17.875 26.625 17.5094 26.625 17.0625V15.4375C26.625 14.9906 26.2594 14.625 25.8125 14.625ZM25.8125 8.125H1.4375C0.990625 8.125 0.625 8.49062 0.625 8.9375V10.5625C0.625 11.0094 0.990625 11.375 1.4375 11.375H25.8125C26.2594 11.375 26.625 11.0094 26.625 10.5625V8.9375C26.625 8.49062 26.2594 8.125 25.8125 8.125Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_393_15460">
          <rect width="30" height="30" fill="white" transform="translate(0.625)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const LongAnswerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path d="M24.875 12.25H2.375C1.96094 12.25 1.625 12.5859 1.625 13C1.625 13.4141 1.96094 13.75 2.375 13.75H24.875C25.2891 13.75 25.625 13.4141 25.625 13C25.625 12.5859 25.2891 12.25 24.875 12.25Z" fill="currentColor" />
      <path d="M24.875 16.75H2.375C1.96094 16.75 1.625 17.0859 1.625 17.5C1.625 17.9141 1.96094 18.25 2.375 18.25H24.875C25.2891 18.25 25.625 17.9141 25.625 17.5C25.625 17.0859 25.2891 16.75 24.875 16.75Z" fill="currentColor" />
      <path d="M24.875 21.75H2.375C1.96094 21.75 1.625 22.0859 1.625 22.5C1.625 22.9141 1.96094 23.25 2.375 23.25H24.875C25.2891 23.25 25.625 22.9141 25.625 22.5C25.625 22.0859 25.2891 21.75 24.875 21.75Z" fill="currentColor" />
      <path d="M2.375 4.75H24.875C25.2891 4.75 25.625 4.41406 25.625 4C25.625 3.58594 25.2891 3.25 24.875 3.25H2.375C1.96094 3.25 1.625 3.58594 1.625 4C1.625 4.41406 1.96094 4.75 2.375 4.75Z" fill="currentColor" />
      <path d="M24.875 7.75H2.375C1.96094 7.75 1.625 8.08594 1.625 8.5C1.625 8.91406 1.96094 9.25 2.375 9.25H24.875C25.2891 9.25 25.625 8.91406 25.625 8.5C25.625 8.08594 25.2891 7.75 24.875 7.75Z" fill="currentColor" />
    </svg>
  )
}

export const MultipleChoiceIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M23.0416 12.0417V13C23.0403 15.2463 22.3129 17.432 20.968 19.2311C19.623 21.0302 17.7325 22.3464 15.5784 22.9833C13.4243 23.6201 11.1221 23.5437 9.01499 22.7652C6.90792 21.9868 5.10893 20.548 3.88634 18.6636C2.66374 16.7792 2.08303 14.5501 2.23083 12.3087C2.37863 10.0673 3.24701 7.93369 4.70646 6.22614C6.16591 4.51858 8.13824 3.32854 10.3293 2.83351C12.5203 2.33847 14.8127 2.56496 16.8645 3.47919" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23.0417 4.66675L12.625 15.0938L9.5 11.9688" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const MultiSelectIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M9.22734 12.5227C9.54219 12.8426 9.95859 13 10.375 13C10.7914 13 11.2068 12.8413 11.5237 12.5239L19.6487 4.39893C19.9676 4.0818 20.125 3.6659 20.125 3.25C20.125 2.32172 19.3658 1.625 18.5 1.625C18.0842 1.625 17.6682 1.78369 17.3513 2.10107L10.375 9.07969L7.46016 6.16484C7.14531 5.84492 6.72891 5.6875 6.3125 5.6875C5.44668 5.6875 4.6875 6.38473 4.6875 7.3125C4.6875 7.7283 4.84619 8.1443 5.16357 8.46117L9.22734 12.5227ZM25 9.75C25 8.82172 24.2408 8.125 23.375 8.125C22.9592 8.125 22.5432 8.28369 22.2263 8.60107L10.375 20.4547L5.02418 15.1023C4.7068 14.7824 4.2909 14.625 3.875 14.625C3.00918 14.625 2.25 15.3222 2.25 16.25C2.25 16.6658 2.40869 17.0818 2.72607 17.3987L9.22607 23.8987C9.54219 24.2176 9.95859 24.375 10.375 24.375C10.7914 24.375 11.2068 24.2163 11.5237 23.8989L24.5237 10.8989C24.8426 10.5828 25 10.1664 25 9.75Z" fill="currentColor" />
    </svg>

  )
}

export const CheckBoxIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_393_15487)">
        <path d="M12 14.6667L16 18.6667L26.6667 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M26.6666 16.0002V24.0002C26.6666 24.7074 26.3856 25.3857 25.8855 25.8858C25.3854 26.3859 24.7072 26.6668 23.9999 26.6668H7.99992C7.29267 26.6668 6.6144 26.3859 6.1143 25.8858C5.6142 25.3857 5.33325 24.7074 5.33325 24.0002V8.00016C5.33325 7.29292 5.6142 6.61464 6.1143 6.11454C6.6144 5.61445 7.29267 5.3335 7.99992 5.3335H19.9999" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_393_15487">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const DataEntry = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_452_48528)">
        <path
          d="M20 0H4.00001C3.03559 0 2.11066 0.395088 1.42871 1.09835C0.746763 1.80161 0.363647 2.75544 0.363647 3.75V20.25C0.363647 21.2446 0.746763 22.1984 1.42871 22.9016C2.11066 23.6049 3.03559 24 4.00001 24H20C20.9644 24 21.8894 23.6049 22.5713 22.9016C23.2533 22.1984 23.6364 21.2446 23.6364 20.25V3.75C23.6364 2.75544 23.2533 1.80161 22.5713 1.09835C21.8894 0.395088 20.9644 0 20 0ZM4.00001 1.5H20C20.5787 1.5 21.1336 1.73705 21.5428 2.15901C21.952 2.58097 22.1818 3.15326 22.1818 3.75V6H1.81819V3.75C1.81819 3.15326 2.04806 2.58097 2.45723 2.15901C2.8664 1.73705 3.42136 1.5 4.00001 1.5ZM1.81819 20.25V7.5H7.63637V22.5H4.00001C3.42136 22.5 2.8664 22.2629 2.45723 21.841C2.04806 21.419 1.81819 20.8467 1.81819 20.25ZM20 22.5H9.09092V7.5H22.1818V20.25C22.1818 20.8467 21.952 21.419 21.5428 21.841C21.1336 22.2629 20.5787 22.5 20 22.5ZM3.27274 9.75C3.27274 9.55109 3.34936 9.36032 3.48575 9.21967C3.62214 9.07902 3.80713 9 4.00001 9H5.45456C5.64744 9 5.83243 9.07902 5.96882 9.21967C6.10521 9.36032 6.18183 9.55109 6.18183 9.75C6.18183 9.94891 6.10521 10.1397 5.96882 10.2803C5.83243 10.421 5.64744 10.5 5.45456 10.5H4.00001C3.80713 10.5 3.62214 10.421 3.48575 10.2803C3.34936 10.1397 3.27274 9.94891 3.27274 9.75ZM6.18183 14.25C6.18183 14.4489 6.10521 14.6397 5.96882 14.7803C5.83243 14.921 5.64744 15 5.45456 15H4.00001C3.80713 15 3.62214 14.921 3.48575 14.7803C3.34936 14.6397 3.27274 14.4489 3.27274 14.25C3.27274 14.0511 3.34936 13.8603 3.48575 13.7197C3.62214 13.579 3.80713 13.5 4.00001 13.5H5.45456C5.64744 13.5 5.83243 13.579 5.96882 13.7197C6.10521 13.8603 6.18183 14.0511 6.18183 14.25ZM6.18183 18.75C6.18183 18.9489 6.10521 19.1397 5.96882 19.2803C5.83243 19.421 5.64744 19.5 5.45456 19.5H4.00001C3.80713 19.5 3.62214 19.421 3.48575 19.2803C3.34936 19.1397 3.27274 18.9489 3.27274 18.75C3.27274 18.5511 3.34936 18.3603 3.48575 18.2197C3.62214 18.079 3.80713 18 4.00001 18H5.45456C5.64744 18 5.83243 18.079 5.96882 18.2197C6.10521 18.3603 6.18183 18.5511 6.18183 18.75ZM20.7273 9.75C20.7273 9.94891 20.6507 10.1397 20.5143 10.2803C20.3779 10.421 20.1929 10.5 20 10.5H11.2727C11.0799 10.5 10.8949 10.421 10.7585 10.2803C10.6221 10.1397 10.5455 9.94891 10.5455 9.75C10.5455 9.55109 10.6221 9.36032 10.7585 9.21967C10.8949 9.07902 11.0799 9 11.2727 9H20C20.1929 9 20.3779 9.07902 20.5143 9.21967C20.6507 9.36032 20.7273 9.55109 20.7273 9.75ZM20.7273 14.25C20.7273 14.4489 20.6507 14.6397 20.5143 14.7803C20.3779 14.921 20.1929 15 20 15H11.2727C11.0799 15 10.8949 14.921 10.7585 14.7803C10.6221 14.6397 10.5455 14.4489 10.5455 14.25C10.5455 14.0511 10.6221 13.8603 10.7585 13.7197C10.8949 13.579 11.0799 13.5 11.2727 13.5H20C20.1929 13.5 20.3779 13.579 20.5143 13.7197C20.6507 13.8603 20.7273 14.0511 20.7273 14.25ZM20.7273 18.75C20.7273 18.9489 20.6507 19.1397 20.5143 19.2803C20.3779 19.421 20.1929 19.5 20 19.5H11.2727C11.0799 19.5 10.8949 19.421 10.7585 19.2803C10.6221 19.1397 10.5455 18.9489 10.5455 18.75C10.5455 18.5511 10.6221 18.3603 10.7585 18.2197C10.8949 18.079 11.0799 18 11.2727 18H20C20.1929 18 20.3779 18.079 20.5143 18.2197C20.6507 18.3603 20.7273 18.5511 20.7273 18.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clippath id="clip0_452_48528">
          <rect
            width="23.2727"
            height="24"
            fill="white"
            transform="translate(0.363647)"
          />
        </clippath>
      </defs>
    </svg>
  );
};

export const DataSelection = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2 18C2 16.1144 2 15.1716 2.58579 14.5858C3.17157 14 4.11438 14 6 14H18C19.8856 14 20.8284 14 21.4142 14.5858C22 15.1716 22 16.1144 22 18C22 19.8856 22 20.8284 21.4142 21.4142C20.8284 22 19.8856 22 18 22H6C4.11438 22 3.17157 22 2.58579 21.4142C2 20.8284 2 19.8856 2 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M2 7C2 5.11438 2 4.17157 2.58579 3.58579C3.17157 3 4.11438 3 6 3H18C19.8856 3 20.8284 3 21.4142 3.58579C22 4.17157 22 5.11438 22 7C22 8.88562 22 9.82843 21.4142 10.4142C20.8284 11 19.8856 11 18 11H6C4.11438 11 3.17157 11 2.58579 10.4142C2 9.82843 2 8.88562 2 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11 7H18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6 7H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11 18H18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6 18H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const MultipleSelection = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.4649 7.51093C17.1768 7.22752 16.7146 7.22783 16.4269 7.51162L12.6506 11.2367C12.2623 11.6198 11.6387 11.621 11.2489 11.2396L10.5708 10.5761C10.282 10.2935 9.81984 10.295 9.53294 10.5795C9.23991 10.8702 9.2415 11.3444 9.53648 11.6331L11.2531 13.3129C11.6429 13.6943 12.2665 13.6931 12.6547 13.3101L17.4656 8.56459C17.7594 8.27472 17.7591 7.80041 17.4649 7.51093Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 2C5.67157 2 5 2.67157 5 3.5V17.5C5 18.3284 5.67157 19 6.5 19H20.5C21.3284 19 22 18.3284 22 17.5V3.5C22 2.67157 21.3284 2 20.5 2H6.5ZM20.4062 4.59375C20.4062 4.04147 19.9585 3.59375 19.4062 3.59375H7.59375C7.04147 3.59375 6.59375 4.04147 6.59375 4.59375V16.4062C6.59375 16.9585 7.04147 17.4062 7.59375 17.4062H19.4062C19.9585 17.4062 20.4062 16.9585 20.4062 16.4062V4.59375Z"
        fill="currentColor"
      />
      <path
        d="M2 5.79688C2 5.35677 2.35677 5 2.79688 5C3.23698 5 3.59375 5.35677 3.59375 5.79687V19.4062C3.59375 19.9585 4.04147 20.4062 4.59375 20.4062H18.2031C18.6432 20.4062 19 20.763 19 21.2031C19 21.6432 18.6432 22 18.2031 22H4C2.89543 22 2 21.1046 2 20V5.79688Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Survey = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.5 6.5H13.375M6.5 12H17.5M6.5 17.5H10.625M5.4 1H18.6C20.1401 1 20.9103 1 21.4985 1.29974C22.0159 1.56338 22.4367 1.98407 22.7003 2.50153C23 3.08978 23 3.85986 23 5.4V18.6C23 20.1401 23 20.9103 22.7003 21.4985C22.4367 22.0159 22.0159 22.4367 21.4985 22.7003C20.9103 23 20.1401 23 18.6 23H5.4C3.85986 23 3.08978 23 2.50153 22.7003C1.98407 22.4367 1.56338 22.0159 1.29974 21.4985C1 20.9103 1 20.1401 1 18.6V5.4C1 3.85986 1 3.08978 1.29974 2.50153C1.56338 1.98407 1.98407 1.56338 2.50153 1.29974C3.08978 1 3.85986 1 5.4 1Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Quiz = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M9.60885 4.49512H6.86375C5.34767 4.49512 4.11865 5.72414 4.11865 7.24022V23.7108C4.11865 25.2269 5.34767 26.4559 6.86375 26.4559H20.5892C22.1054 26.4559 23.3343 25.2269 23.3343 23.7108V7.24022C23.3343 5.72414 22.1054 4.49512 20.5892 4.49512H17.8441"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7266 14.103H17.8442"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7266 19.593H17.8442"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.60791 4.4951C9.60791 2.97902 10.8369 1.75 12.353 1.75H15.0981C16.6142 1.75 17.8432 2.97902 17.8432 4.4951V7.2402H9.60791V4.4951Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.60644 15.4758C10.3645 15.4758 10.979 14.8613 10.979 14.1033C10.979 13.3452 10.3645 12.7307 9.60644 12.7307C8.8484 12.7307 8.23389 13.3452 8.23389 14.1033C8.23389 14.8613 8.8484 15.4758 9.60644 15.4758Z"
        fill="currentColor"
      />
      <path
        d="M9.60644 20.9658C10.3645 20.9658 10.979 20.3513 10.979 19.5933C10.979 18.8352 10.3645 18.2207 9.60644 18.2207C8.8484 18.2207 8.23389 18.8352 8.23389 19.5933C8.23389 20.3513 8.8484 20.9658 9.60644 20.9658Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UploadForm = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_452_48566)">
        <path
          d="M8.5 17V10M8.5 10L11 13M8.5 10L6 13"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5 17V10M15.5 10L18 13M15.5 10L13 13"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 7H12H6"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M1 12C1 6.81455 1 4.22182 2.61092 2.61092C4.22182 1 6.81455 1 12 1C17.1854 1 19.7782 1 21.389 2.61092C23 4.22182 23 6.81455 23 12C23 17.1854 23 19.7782 21.389 21.389C19.7782 23 17.1854 23 12 23C6.81455 23 4.22182 23 2.61092 21.389C1 19.7782 1 17.1854 1 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clippath id="clip0_452_48566">
          <rect width="24" height="24" fill="white" />
        </clippath>
      </defs>
    </svg>
  );
};

export const SatisfactionScore = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.0001 6.25L13.1801 8.76L15.8201 9.17L13.9101 11.12L14.3601 13.89L12.0001 12.58L9.64005 13.89L10.0901 11.12L8.18005 9.17L10.8201 8.76L12.0001 6.25Z"
        fill="currentColor"
      />
      <path
        d="M18.68 1.47998H5.32C4.30687 1.47998 3.33524 1.88244 2.61885 2.59883C1.90246 3.31522 1.5 4.28685 1.5 5.29998V14.84C1.5 15.8531 1.90246 16.8247 2.61885 17.5411C3.33524 18.2575 4.30687 18.66 5.32 18.66H9.14L12 21.52L14.86 18.66H18.68C19.6931 18.66 20.6648 18.2575 21.3811 17.5411C22.0975 16.8247 22.5 15.8531 22.5 14.84V5.29998C22.5 4.28685 22.0975 3.31522 21.3811 2.59883C20.6648 1.88244 19.6931 1.47998 18.68 1.47998Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const TrashIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.8298 4C13.4477 4 14.5023 4.83988 14.8403 6.38266L18.9787 6.38298C19.3547 6.38298 19.6596 6.68781 19.6596 7.06383C19.6596 7.43985 19.3547 7.74468 18.9787 7.74468H18.2264L17.1287 18.1713C17.0192 19.2108 16.1426 20 15.0973 20H8.56224C7.51694 20 6.64033 19.2108 6.53091 18.1713L5.43319 7.74468H4.68085C4.30483 7.74468 4 7.43985 4 7.06383C4 6.68781 4.30483 6.38298 4.68085 6.38298L8.81924 6.38266C9.15732 4.83988 10.2118 4 11.8298 4ZM16.8565 7.74468H6.80238L7.88513 18.0287C7.9216 18.3752 8.21381 18.6383 8.56224 18.6383H15.0973C15.4458 18.6383 15.738 18.3752 15.7744 18.0287L16.8565 7.74468ZM11.8298 9.10638C12.2058 9.10638 12.5106 9.41121 12.5106 9.78723V16.5957C12.5106 16.9718 12.2058 17.2766 11.8298 17.2766C11.4538 17.2766 11.1489 16.9718 11.1489 16.5957V9.78723C11.1489 9.41121 11.4538 9.10638 11.8298 9.10638ZM14.5872 9.10723C14.9627 9.12601 15.252 9.44568 15.2332 9.82123L14.8928 16.6297C14.874 17.0053 14.5543 17.2945 14.1788 17.2757C13.8032 17.257 13.514 16.9373 13.5328 16.5617L13.8732 9.75323C13.892 9.37768 14.2116 9.08845 14.5872 9.10723ZM9.07238 9.10723C9.44794 9.08845 9.76761 9.37768 9.78639 9.75323L10.1268 16.5617C10.1456 16.9373 9.85636 17.257 9.48081 17.2757C9.10525 17.2945 8.78558 17.0053 8.76681 16.6297L8.42638 9.82123C8.4076 9.44568 8.69683 9.12601 9.07238 9.10723ZM11.8298 5.3617C10.9673 5.3617 10.4683 5.67088 10.2283 6.38268H13.4313C13.1913 5.67088 12.6922 5.3617 11.8298 5.3617Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CogIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="14"
      viewBox="0 0 9 14"
      fill="none"
    >
      <rect
        x="6.10352e-05"
        width="2.80072"
        height="2.80072"
        rx="0.700065"
        fill="currentColor"
      />
      <rect
        x="5.60156"
        width="2.80072"
        height="2.80072"
        rx="0.700065"
        fill="currentColor"
      />
      <rect
        x="5.60071"
        y="5.60059"
        width="2.80072"
        height="2.80072"
        rx="0.700065"
        fill="currentColor"
      />
      <rect
        x="0.00012207"
        y="5.60059"
        width="2.80072"
        height="2.80072"
        rx="0.700065"
        fill="currentColor"
      />
      <rect
        x="0.00012207"
        y="11.201"
        width="2.80072"
        height="2.80072"
        rx="0.700065"
        fill="currentColor"
      />
      <rect
        x="5.60071"
        y="11.201"
        width="2.80072"
        height="2.80072"
        rx="0.700065"
        fill="currentColor"
      />
    </svg>
  );
};

export const CheckAnswer = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8006 12.1912C20.043 12.4294 20.0648 12.8074 19.8637 13.0707L15.2337 17.8006C14.993 18.0456 14.6102 18.0649 14.3471 17.8582L11.5258 15.01C11.267 14.7481 11.2695 14.326 11.5315 14.0672C11.7732 13.8284 12.1515 13.8122 12.4118 14.0171L14.7567 16.3833L18.8579 12.1994C19.1159 11.9368 19.538 11.9331 19.8006 12.1912ZM8.66667 14C9.03486 14 9.33333 14.2985 9.33333 14.6667C9.33333 15.0349 9.03486 15.3333 8.66667 15.3333H4.66667C4.29848 15.3333 4 15.0349 4 14.6667C4 14.2985 4.29848 14 4.66667 14H8.66667ZM16.6667 10C17.0349 10 17.3333 10.2985 17.3333 10.6667C17.3333 11.0349 17.0349 11.3333 16.6667 11.3333H4.66667C4.29848 11.3333 4 11.0349 4 10.6667C4 10.2985 4.29848 10 4.66667 10H16.6667ZM16.6667 6C17.0349 6 17.3333 6.29848 17.3333 6.66667C17.3333 7.03486 17.0349 7.33333 16.6667 7.33333H4.66667C4.29848 7.33333 4 7.03486 4 6.66667C4 6.29848 4.29848 6 4.66667 6H16.6667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.073 4.98242V16.6491M4.23969 10.8158H15.9064"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
